import { Col, Row } from "antd";
import { FormSegmented } from "components/form/FormProvide";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const WeeklyPeriod = ({
    options = []
}) => {
    const { t } = useTranslation();
    const [value, setValue] = useState('onePeriod');

    return (
        <Row style={{ width: "100%" }}>
            <Col span={12}>
                <FormSegmented
                    name="paymentDay"
                    label={t("payroll_period.day_payment")}
                    required={true}
                    size="large"
                    options={options}
                    value={value}
                    onChange={setValue}
                />
            </Col>
        </Row>
    )
}

export default WeeklyPeriod;